export default {"src":"/_next/static/media/prev.52ece04b.svg","height":16,"width":205,"blurWidth":0,"blurHeight":0};